import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chart-pivot-table-icon',
  templateUrl: 'chart-pivot-table-icon.component.html'
})
export class ChartPivotTableIconComponent {
  constructor() {}
}
